import { Box, Text } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import type { ComponentProps } from 'react';

type BoxProps = ComponentProps<typeof Box>;
type TextProps = ComponentProps<typeof Text>;

export const TableHeaderCell = ({
  align = 'left',
  children,
  dataTestId,
  paddingLeft = 'small',
  paddingRight = 'small',
}: {
  align?: TextProps['align'];
  children: React.ReactNode;
  dataTestId?: string;
  paddingLeft?: BoxProps['paddingLeft'];
  paddingRight?: BoxProps['paddingRight'];
}) => (
  <Box
    background="neutralLight"
    component="th"
    data-testid={dataTestId}
    paddingY="small"
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    style={{
      whiteSpace: 'nowrap',
    }}
  >
    <Text size="small" align={align} weight="medium">
      {children}
    </Text>
  </Box>
);

export const TableCell = ({
  children,
  maxWidth,
  minWidth,
  paddingLeft = 'small',
  paddingRight = 'small',
  width,
}: {
  children: React.ReactNode;
  maxWidth?: number;
  minWidth?: number;
  paddingLeft?: BoxProps['paddingLeft'];
  paddingRight?: BoxProps['paddingRight'];
  width?: '100%' | number;
}) => (
  <Box
    component="td"
    paddingY="medium"
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    style={{
      borderTop: `${vars.borderWidth.standard} solid ${vars.borderColor.neutralLight}`,
      maxWidth,
      minWidth,
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      width,
      textWrap: 'wrap',
    }}
  >
    {children}
  </Box>
);

export const Table = ({ children }: { children: React.ReactNode }) => (
  <Box
    style={{
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
    }}
  >
    <Box
      borderRadius="large"
      component="table"
      width="full"
      cellSpacing={0}
      cellPadding={0}
      overflow="hidden"
      style={{
        borderCollapse: 'separate',
        border: `${vars.borderWidth.standard} solid ${vars.borderColor.neutralLight}`,
      }}
    >
      {children}
    </Box>
  </Box>
);
